import { LegacyTripItemReceiptController } from './legacy-trip-item-receipt-controller';
import { MyListCustomerMigrationController } from './my-list-customer-migration-controller';
import { TripItemDetailsController } from './trip-item-details-controller';
import { TripItemEssentialInfoController } from './trip-item-essential-info-controller';
import { TripItemItineraryController } from './trip-item-itinerary-controller';
import { TripItemReceiptController } from './trip-item-receipt-controller';
import { TripItemVoucherController } from './trip-item-voucher-controller';
import { TripItemVoucherPrintController } from './trip-item-voucher-print-controller';
import { TripManageBookingController } from './trip-manage-booking-controller';
import { TripManageGuestsController } from './trip-manage-guests-controller';
import { TripOverviewController } from './trip-overview-controller';
import { TripOverviewItineraryController } from './trip-overview-itinerary-controller';
import { TripPendingInviteController } from './trip-pending-invite-controller';
import { TripPricingDetailsController } from './trip-pricing-details-controller';
import { TripsBookingSearchController } from './trips-booking-search-controller';
import { TripsController } from './trips-controller';
import { TripsFilteredController } from './trips-filtered-controller';
import { TripsFindItineraryNumberController } from './trips-find-itinerary-number-controller';

export const controllers = [
  TripsController,
  TripManageGuestsController,
  TripPendingInviteController,
  TripsFilteredController,
  TripsBookingSearchController,
  TripsFindItineraryNumberController,
  TripOverviewController,
  TripItemDetailsController,
  TripItemEssentialInfoController,
  TripPricingDetailsController,
  TripManageBookingController,
  TripItemReceiptController,
  TripItemVoucherController,
  TripItemVoucherPrintController,
  TripItemItineraryController,
  TripOverviewItineraryController,
  LegacyTripItemReceiptController,
  MyListCustomerMigrationController
];
